// Generated by ReScript, PLEASE EDIT WITH CARE


import { t } from '@lingui/macro'
;

function orderLink(sku, orderId) {
  return `/products/gallery/` + sku + `/` + orderId + `?order=1`;
}

function galleryLink(sku) {
  return `/gallery/featured/` + sku;
}

function productLink(sku) {
  return `/products/` + sku;
}

function artistLink(username) {
  return `/artists/` + username;
}

let hiddenSkus = ["digital-portrait-painting-canvas"];

function isHidden(sku) {
  return hiddenSkus.includes(sku);
}

function mediumLabel(sku) {
  switch (sku) {
    case "custcharcoal" :
      return t`Charcoal drawing`;
    case "custcoloredpencil" :
      return t`Colored pencil drawing`;
    case "custmixedmedia" :
      return t`Mixed-media painting`;
    case "custpencil" :
      return t`Pencil drawing`;
    case "custphotoreal" :
      return t`Oil painting`;
    case "custwatercolor" :
      return t`Watercolor painting`;
    case "digital-portrait-painting-canvas" :
      return t`Digital portrait`;
    default:
      return sku;
  }
}

function truncateReview(text) {
  if (text.length <= 120) {
    return text;
  }
  let head = text.slice(0, 120);
  let index = head.lastIndexOf(" ");
  let cut = index !== -1 ? index : 120;
  return head.slice(0, cut).trim() + t`… (full review on order page)`;
}

function reviewerAttribution(name, city, country) {
  let place = city !== undefined ? (
      country !== undefined ? city + `, ` + country : city
    ) : (
      country !== undefined ? country : ""
    );
  if (place === "") {
    return name;
  } else {
    return t`${name} from ${place}`;
  }
}

function formatDate(ms) {
  let date = new Date(ms);
  let pad = n => {
    if (n < 10) {
      return "0" + n.toString();
    } else {
      return n.toString();
    }
  };
  return pad(date.getUTCMonth() + 1 | 0) + `/` + pad(date.getUTCDate()) + `/` + date.getUTCFullYear().toString();
}

function formatCount(n) {
  let digits = n.toString();
  let _end = digits.length;
  let _acc = "";
  while (true) {
    let acc = _acc;
    let end = _end;
    if (end <= 0) {
      return acc;
    }
    let start = (end - 3 | 0) < 0 ? 0 : end - 3 | 0;
    let chunk = digits.slice(start, end);
    _acc = acc === "" ? chunk : chunk + "," + acc;
    _end = start;
    continue;
  };
}

function flagEmoji(countryCode) {
  let code = countryCode.trim().toUpperCase();
  if (code.length !== 2) {
    return "";
  } else {
    return code.split("").map(letter => {
      let point = letter.codePointAt(0);
      if (point !== undefined && point >= 65 && point <= 90) {
        return String.fromCodePoint(127462 + (point - 65 | 0) | 0);
      } else {
        return "";
      }
    }).join("");
  }
}

let allArtistsLink = "/artists";

let orderFormLink = "/products/order";

let madeInAmericaLink = "/gallery/made-in-america";

let reviewsLink = "/reviews";

let pressLink = "/press";

let reviewMaxLength = 120;

export {
  orderLink,
  galleryLink,
  productLink,
  artistLink,
  allArtistsLink,
  orderFormLink,
  madeInAmericaLink,
  reviewsLink,
  pressLink,
  hiddenSkus,
  isHidden,
  mediumLabel,
  reviewMaxLength,
  truncateReview,
  reviewerAttribution,
  formatDate,
  formatCount,
  flagEmoji,
}
/*  Not a pure module */
